export const weeks = [
  { key: "Last 4 Weeks", value: 4, text: "Last 4 Weeks" },
  { key: "Last 8 Weeks", value: 8, text: "Last 8 Weeks" },
  { key: "Last 12 Weeks", value: 12, text: "Last 12 Weeks" },
];

export const groupBy = [
  { key: "Site", value: 0, text: "Site" },
  { key: "Region", value: 1, text: "Region" },
];

export const promoTypeOptions = [
  { key: "All (Default)", value: -1, text: "All (Default)" },
  { key: "Promo Cash", value: 1, text: "Promo Cash" },
  { key: "Promo Tickets", value: 2, text: "Promo Tickets" },
];
